import { render, staticRenderFns } from "./luck-rank.vue?vue&type=template&id=179357e8&scoped=true&"
import script from "./luck-rank.vue?vue&type=script&lang=js&"
export * from "./luck-rank.vue?vue&type=script&lang=js&"
import style0 from "./luck-rank.vue?vue&type=style&index=0&id=179357e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179357e8",
  null
  
)

export default component.exports